// Real-world synodic month, anchored to a known New Moon (2000-01-06 18:14 UTC).
const SYNODIC_MONTH_DAYS = 29.53058867;
const KNOWN_NEW_MOON_UTC = Date.UTC(2000, 0, 6, 18, 14, 0);
const MS_PER_DAY = 86400000;

const moonAgeDays = (year, month, day) => {
  const ms = Date.UTC(year, month, day, 12, 0, 0) - KNOWN_NEW_MOON_UTC;
  const age = (ms / MS_PER_DAY) % SYNODIC_MONTH_DAYS;
  return age < 0 ? age + SYNODIC_MONTH_DAYS : age;
};

const distanceToTarget = (age, target) => {
  const diff = Math.abs(age - target);
  return Math.min(diff, SYNODIC_MONTH_DAYS - diff);
};

const addDays = (year, month, day, delta) => new Date(year, month, day + delta);

// Returns 'new', 'full', or null. A day is marked only when it is the closest
// calendar day to an exact New or Full moon among itself and its neighbors,
// so each ~29.5-day cycle gets one New and one Full mark.
export const getMoonMarker = (year, month, day) => {
  const prev = addDays(year, month, day, -1);
  const next = addDays(year, month, day, 1);

  const ageCur = moonAgeDays(year, month, day);
  const agePrev = moonAgeDays(prev.getFullYear(), prev.getMonth(), prev.getDate());
  const ageNext = moonAgeDays(next.getFullYear(), next.getMonth(), next.getDate());

  const newDistCur = distanceToTarget(ageCur, 0);
  const newDistPrev = distanceToTarget(agePrev, 0);
  const newDistNext = distanceToTarget(ageNext, 0);
  if (newDistCur < newDistPrev && newDistCur <= newDistNext) return 'new';

  const fullTarget = SYNODIC_MONTH_DAYS / 2;
  const fullDistCur = distanceToTarget(ageCur, fullTarget);
  const fullDistPrev = distanceToTarget(agePrev, fullTarget);
  const fullDistNext = distanceToTarget(ageNext, fullTarget);
  if (fullDistCur < fullDistPrev && fullDistCur <= fullDistNext) return 'full';

  return null;
};
